export const loadMoreAddToCollectionModalCollections = ({ userId, limit = 5, pagingToken, selectedPost }) => ({
  type: "LOAD_MORE_ADD_TO_COLLECTION_MODAL_COLLECTIONS_REQUEST",
  userId,
  limit,
  pagingToken,
  selectedPost,
});

export const loadMoreAddToCollectionModalCollectionsSuccess = ({ collections, limit, pagingToken }) => ({
  type: "LOAD_MORE_ADD_TO_COLLECTION_MODAL_COLLECTIONS_SUCCESS",
  collections,
  limit,
  pagingToken,
});



// WEBPACK FOOTER //
// ./src/components/AddToCollectionModal/actions.js